export const GROUP_INFO_FORM_TEST = Object.freeze<Record<string, string>>({
  firstName: 'group-info-first-name',
  lastName: 'group-info-last-name',
  primaryPhone: 'group-info-primary-phone',
  primaryEmail: 'group-info-primary-email',
  title: 'group-info-title',
  city: 'group-info-city',
  street: 'group-info-street',
  street2: 'group-info-street2',
  state: 'group-info-state',
  county: 'group-info-county',
  zip: 'group-info-zip',
});
export const MAIN_CONTACT_INFO_TEST = 'main-contact-information-section';
export const PHYSICAL_ADDRESS_INFO_TEST = 'physical-address-information-section';

export const REMOVE_GROUP_WARNING_MODAL = 'remove-group-warning-modal';
